export var checkItemMap = {
  lg: {
    checkItemSize: 24,
    labelTextSize: 'xl',
    textMargin: 12
  },
  md: {
    checkItemSize: 24,
    labelTextSize: 'lg',
    textMargin: 12
  },
  sm: {
    checkItemSize: 24,
    labelTextSize: 'lg',
    textMargin: 12
  },
  xs: {
    checkItemSize: 16,
    labelTextSize: 'md',
    textMargin: 8
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL21vbGVjdWxlcy9DaGVja2JveFJhZGlvQnVpbGRlci9jb25maWcudHMiXSwibmFtZXMiOlsiY2hlY2tJdGVtTWFwIiwibGciLCJjaGVja0l0ZW1TaXplIiwibGFiZWxUZXh0U2l6ZSIsInRleHRNYXJnaW4iLCJtZCIsInNtIiwieHMiXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sSUFBTUEsWUFBWSxHQUFHO0FBQzFCQyxFQUFBQSxFQUFFLEVBQUU7QUFDRkMsSUFBQUEsYUFBYSxFQUFFLEVBRGI7QUFFRkMsSUFBQUEsYUFBYSxFQUFFLElBRmI7QUFHRkMsSUFBQUEsVUFBVSxFQUFFO0FBSFYsR0FEc0I7QUFNMUJDLEVBQUFBLEVBQUUsRUFBRTtBQUNGSCxJQUFBQSxhQUFhLEVBQUUsRUFEYjtBQUVGQyxJQUFBQSxhQUFhLEVBQUUsSUFGYjtBQUdGQyxJQUFBQSxVQUFVLEVBQUU7QUFIVixHQU5zQjtBQVcxQkUsRUFBQUEsRUFBRSxFQUFFO0FBQ0ZKLElBQUFBLGFBQWEsRUFBRSxFQURiO0FBRUZDLElBQUFBLGFBQWEsRUFBRSxJQUZiO0FBR0ZDLElBQUFBLFVBQVUsRUFBRTtBQUhWLEdBWHNCO0FBZ0IxQkcsRUFBQUEsRUFBRSxFQUFFO0FBQ0ZMLElBQUFBLGFBQWEsRUFBRSxFQURiO0FBRUZDLElBQUFBLGFBQWEsRUFBRSxJQUZiO0FBR0ZDLElBQUFBLFVBQVUsRUFBRTtBQUhWO0FBaEJzQixDQUFyQiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBjaGVja0l0ZW1NYXAgPSB7XG4gIGxnOiB7XG4gICAgY2hlY2tJdGVtU2l6ZTogMjQsXG4gICAgbGFiZWxUZXh0U2l6ZTogJ3hsJyxcbiAgICB0ZXh0TWFyZ2luOiAxMixcbiAgfSxcbiAgbWQ6IHtcbiAgICBjaGVja0l0ZW1TaXplOiAyNCxcbiAgICBsYWJlbFRleHRTaXplOiAnbGcnLFxuICAgIHRleHRNYXJnaW46IDEyLFxuICB9LFxuICBzbToge1xuICAgIGNoZWNrSXRlbVNpemU6IDI0LFxuICAgIGxhYmVsVGV4dFNpemU6ICdsZycsXG4gICAgdGV4dE1hcmdpbjogMTIsXG4gIH0sXG4gIHhzOiB7XG4gICAgY2hlY2tJdGVtU2l6ZTogMTYsXG4gICAgbGFiZWxUZXh0U2l6ZTogJ21kJyxcbiAgICB0ZXh0TWFyZ2luOiA4LFxuICB9LFxufSBhcyBjb25zdFxuIl19